import { createSlice } from '@reduxjs/toolkit';
import {RootState} from './store'

export const localeSlice = createSlice({
  name: 'locale',
  initialState: {
  	value: window.localStorage.getItem('_snailcle_web_locale_') || 'en',
    curmenu: '/'
  },
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setLocaleVal: (state, actions) => {
      state.value = actions.payload;
    },
    setMenu: (state, actions) => {
      state.curmenu = actions.payload;
    }
  }
});
export const selectLocale = (state: RootState) => state.locale.value;
export const selectMenu = (state: RootState) => state.locale.curmenu;
export const { setLocaleVal, setMenu } = localeSlice.actions;

export default localeSlice.reducer;